import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { PortalContextService } from "@/core/services/portal-context.service";
import { GlobalEnumsAceXfoundportalobjekt } from "@/api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-xfoundportalobjekt";

@Injectable({
    providedIn: 'root'
})
export class AnfrageScopeHttpInterceptor implements HttpInterceptor {
    
    protected oldScope: GlobalEnumsAceXfoundportalobjekt;

    constructor(protected portalContextService: PortalContextService, protected router: Router) { }
    
    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //If there is no current scope based on the url, because the user leaves the anfrage, just take the cached old scope
        const scopeType = this.portalContextService.CurrentItemContext?.type ?? this.oldScope;

        if (scopeType && !req.headers.has('x-anfragescope')) {
            this.oldScope = scopeType;
            req = this.setGlobalEnumsAceXfoundportalobjektHeader(req, scopeType);
        }
        
        return next.handle(req);
    }

    protected setGlobalEnumsAceXfoundportalobjektHeader(request: HttpRequest<any>, scope: GlobalEnumsAceXfoundportalobjekt) {
        return request.clone({
            setHeaders: {
                'x-anfragescope': `${scope}`
            }
        });
    }
}